import { render, staticRenderFns } from "./WombatHeaderDefaultCell.vue?vue&type=template&id=3e51318e&scoped=true"
import script from "./WombatHeaderDefaultCell.vue?vue&type=script&lang=js"
export * from "./WombatHeaderDefaultCell.vue?vue&type=script&lang=js"
import style0 from "./WombatHeaderDefaultCell.vue?vue&type=style&index=0&id=3e51318e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e51318e",
  null
  
)

export default component.exports